/**
 * This use data-slideshow so that it is possible to manually create other
 * types of slideshows if needed.
 *
 * Example:
 * <div data-slideshow> ... <div><img ...></div> ... </div>
 * Some configuration can be passed with data-* attributes on the .bxslider
 * data-fade: 'true', 'false' (default false)
 * data-arrows: 'true', 'false' (default true)
 * data-infinite: 'true', 'false' (default true)
 * data-dots: 'true', 'false' (default false)
 * data-autoplay: 'true', 'false' (default false)
 * data-autoplaySpeed: milliseconds before auto next slide (default 4000)
 *
 * example:
 * <div data-slideshow data-fade="true" data-dots="true">
*/

import $ from 'jquery';

require('slick-carousel');
let hasGlobalResizeHandler = false;

export default class Slideshow {
  constructor($context) {
    // this.$items = $context.find('[data-slideshow]');
    // this.$items.once('slideshow').each((i, el) => {
    //   this.setElement(el);
    // });
    this.onResize();

    if (!hasGlobalResizeHandler) {
      $(window).on('resize', () => this.onResize());
      window.addEventListener('orientationchange', () => this.onResize(), false);
      hasGlobalResizeHandler = true;
    }
  }

  onResize() {
    const WINDOW_WIDTH = $(window).width();
    $('[data-slideshow]').each((i, el) => {
      const $slider = $(el);
      const min = $slider.data('min-width') || 0;
      const max = $slider.data('max-width') || Infinity;

      if (WINDOW_WIDTH < min || WINDOW_WIDTH > max) {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      }
      else if (!$slider.hasClass('slick-initialized')) {
        this.setElement(el);
      }
    });
  }

  setElement(el) {
    const $this = $(el);
    const fade = $this.data('fade') || false;
    const dots = $this.data('dots') || false;
    const infinite = $this.data('infinite') !== undefined ? $this.data('infinite') : true;
    const arrows = $this.data('arrows') !== undefined ? $this.data('arrows') : true;
    const autoplay = $this.data('autoplay') || false;
    const autoplaySpeed = $this.data('autoplaySpeed') || 4000;

    const options = {
      fade,
      dots,
      arrows,
      autoplay,
      autoplaySpeed,
      infinite,
      adaptiveHeight: true,
      speed: 600,
      accessibility: false
    };

    options.prevArrow = '<a href="#" class="slick-arrow slick-prev"><div class="icon-arrow"></div></a>';
    options.nextArrow = '<a href="#" class="slick-arrow slick-next"><div class="icon-arrow"></div></a>';

    // $this.on('init', function(event, slick) {
    //   grunticon.svgLoadedCallback();
    // });

    $this.slick(options);
  }
}



// WEBPACK FOOTER //
// ./4.plugins/Slideshow/Slideshow.js